.root {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.track {
  background: var(--color-muted, #f4f4f5);
  block-size: 4px;
  border-radius: 2px;
  overflow: hidden;
}

.fill {
  background: var(--color-primary, #2563eb);
  block-size: 100%;
  transition: inline-size 0.2s ease;
}
